import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=752ead1c&"
import script from "@/controllers/ap/student/video/Info?v=3.0?vue&type=script&lang=ts&"
export * from "@/controllers/ap/student/video/Info?v=3.0?vue&type=script&lang=ts&"
import style0 from "@/assets/css/main.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports